import { render, staticRenderFns } from "./cash2.vue?vue&type=template&id=ce52a246&scoped=true"
import script from "./cash2.vue?vue&type=script&lang=js"
export * from "./cash2.vue?vue&type=script&lang=js"
import style0 from "./cash2.vue?vue&type=style&index=0&id=ce52a246&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce52a246",
  null
  
)

export default component.exports